
import { useUpdatePlan } from './subscription/useUpdatePlan';
import { useCreateSubscription } from './subscription/useCreateSubscription';
import { useCancelSubscription } from './subscription/useCancelSubscription';

export const useSubscriptionManagement = (refreshData: () => void) => {
  const updateCustomerPlan = useUpdatePlan(refreshData);
  const createCustomerSubscription = useCreateSubscription(refreshData);
  const cancelCustomerSubscription = useCancelSubscription(refreshData);

  return {
    updateCustomerPlan,
    createCustomerSubscription,
    cancelCustomerSubscription
  };
};
